import React from 'react';
import { View } from 'react-native';
import { Button } from '@md-design-system/Button';
import { useI18n } from '@shared/i18n/useI18n';
import { DOCUMENTS_UPLOAD_LABEL_ENABLED_STYLE, DOCUMENTS_UPLOAD_LABEL_STYLE } from '../../constants';
import type { TDocumentsUploadFooterProps } from '../../types';

export const DocumentsUploadFooter = ({ isUploading, onPress }: TDocumentsUploadFooterProps) => {
    const { t } = useI18n();

    return (
        <View className="bg-white px-md py-sm">
            <Button
                variant="primary"
                size="large"
                icon="upload"
                disabled={isUploading}
                onPress={onPress}
                textStyle={isUploading ? DOCUMENTS_UPLOAD_LABEL_STYLE : DOCUMENTS_UPLOAD_LABEL_ENABLED_STYLE}
            >
                {isUploading ? t('documents.upload.uploading') : t('documents.upload.button')}
            </Button>
        </View>
    );
};
